var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vector2i, GetEntries } from "js-vextensions";
import { Column, Pre, Row, RowLR, Select, Spinner } from "react-vcomponents";
import { UpdateMapObject } from "Server/Commands/UpdateMapObject";
import { GetMapObject } from "Store/firebase/mapObjects";
import { DistanceUnit, ShapeType } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { Observer } from "vwebapp-framework";
import { store } from "Store";
import { runInAction } from "mobx";
import { ToolUI } from "./Tool";
import { ShapeDrawer } from "../@Shared/ShapeDrawer";
import { MapObjectUI } from "../MapObjectUI";
let RedrawSegment = class RedrawSegment extends ToolUI({}, {}) {
    render() {
        const targetObject = GetMapObject(store.main.write.tools.redrawSegment.targetObject);
        const minLineLength = store.main.write.tools.addObject.minLineLength;
        const minLineLengthUnit = store.main.write.tools.addObject.minLineLengthUnit;
        if (targetObject == null)
            return React.createElement("div", null);
        const splitAt = 110;
        return (React.createElement(Column, null, [ShapeType.Path, ShapeType.Region].Contains(targetObject.shape.type)
            && React.createElement(RowLR, { mt: 5, splitAt: splitAt },
                React.createElement(Pre, null, "Min line length: "),
                React.createElement(Row, { style: { width: "100%" } },
                    React.createElement(Spinner, { step: .01, style: { minWidth: 0 }, value: minLineLength, onChange: val => {
                            runInAction("RedrawSegment.minLinLength.onChange", () => store.main.write.tools.addObject.minLineLength = val);
                        } }),
                    React.createElement(Select, { options: GetEntries(DistanceUnit), value: minLineLengthUnit, onChange: val => {
                            runInAction("RedrawSegment.minLineLengthUnit.onChange", () => store.main.write.tools.addObject.minLineLengthUnit = val);
                        } })))));
    }
    Scene_OnMouseDown(e) {
        if (e.button != 0)
            return;
        const targetObject = GetMapObject(store.main.write.tools.redrawSegment.targetObject);
        const minLineLength = store.main.write.tools.addObject.minLineLength;
        const minLineLengthUnit = store.main.write.tools.addObject.minLineLengthUnit;
        if (targetObject == null)
            return;
        this.shapeDrawer = new ShapeDrawer();
        this.shapeDrawer.InitContext({ mapScene: this.MapScene, objPosition: targetObject.position });
        this.shapeDrawer.InitToolProps({ minLineLength, minLineLengthUnit });
        this.shapeDrawer.CreateNewShape(targetObject.shape, this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY)));
        this.MapScene.Update();
        this.MapScene.UpdateMapObjectUI(targetObject._key); // re-render map-object-ui for selected obj, causing old shape to be hidden (if any), while we're drawing new one
        return true;
    }
    Scene_OnMouseMove(e) {
        if (!this.shapeDrawer)
            return;
        this.shapeDrawer.UpdateNewShape(this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY)));
        this.MapScene.Update();
        return true;
    }
    Scene_OnMouseUp(e) {
        if (e.button != 0)
            return;
        if (!this.shapeDrawer)
            return;
        const targetObject = GetMapObject(store.main.write.tools.redrawSegment.targetObject);
        this.shapeDrawer.UpdateNewShape(this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY)));
        new UpdateMapObject({ id: targetObject._key, updates: { shape: this.GetNewShape() } }).Run();
        this.shapeDrawer = null;
        this.MapScene.Update();
        runInAction("RedrawSegment.Scene_OnMouseUp", () => store.main.write.selectedTool = null);
        return true;
    }
    GetNewShape() {
        const targetObject = GetMapObject(store.main.write.tools.redrawSegment.targetObject);
        const newPoints = ReplaceSegmentOfPathPoints(targetObject.shape.pathPoints, this.shapeDrawer.shape.pathPoints, g.shiftDown, !g.altDown);
        //return u.updateIn("pathPoints", u.constant(newPoints), targetObject.shape);
        return targetObject.shape.Extended({ pathPoints: newPoints });
    }
    RenderInScene() {
        const targetObject = GetMapObject(store.main.write.tools.redrawSegment.targetObject);
        return this.shapeDrawer
            && React.createElement(MapObjectUI, { obj: targetObject.Extended({ shape: this.GetNewShape() }), mapScene: this.MapScene, worldViewArea: this.MapScene.WorldViewArea() });
    }
    RenderForObject(obj, extraInfo) {
        const targetObject = GetMapObject(store.main.write.tools.redrawSegment.targetObject);
        if (obj == targetObject && this.shapeDrawer) {
            extraInfo.cancelNormalRender = true;
        }
        return null;
    }
};
RedrawSegment = __decorate([
    Observer
], RedrawSegment);
export { RedrawSegment };
export function ReplaceSegmentOfPathPoints(basePoints, replacementSegmentPoints, replaceClosests = false, replaceFewestPoints = true) {
    if (!(basePoints[0] instanceof Vector2i))
        basePoints = basePoints.map(a => a.As(Vector2i));
    const startPointIndex = basePoints.Pairs().OrderBy(a => a.value.DistanceTo(replacementSegmentPoints.First())).First().keyNum;
    const endPointIndex = basePoints.Pairs().OrderBy(a => a.value.DistanceTo(replacementSegmentPoints.Last())).First().keyNum;
    const earlierPointIndex = [startPointIndex, endPointIndex].Min();
    const laterPointIndex = [startPointIndex, endPointIndex].Max();
    /*let deleteCountIfReplacingStartToEnd = (replaceEndPointIndex - replaceStartPointIndex) - 1; // assumes replaceClosest=false
    let deleteCountIfReplacingEndToStart = basePoints.length - deleteCountIfReplacingStartToEnd - 2; // assumes replaceClosest=false*/
    //if (replaceEndPointIndex > replaceStartPointIndex) {
    const replacedContinuous = [...basePoints];
    replacedContinuous.splice(earlierPointIndex + (replaceClosests ? 0 : 1), (laterPointIndex - earlierPointIndex) + (replaceClosests ? 1 : -1), ...startPointIndex == earlierPointIndex ? replacementSegmentPoints : replacementSegmentPoints.Reversed());
    let replacedLooping = basePoints.slice(earlierPointIndex + (replaceClosests ? 1 : 0), laterPointIndex + (replaceClosests ? 0 : 1));
    // if start-point was earlier in array, connect new points to start of array
    if (startPointIndex == earlierPointIndex) {
        replacedLooping = replacementSegmentPoints.Reversed().concat(replacedLooping);
    }
    else {
        replacedLooping = replacedLooping.concat(replacementSegmentPoints);
    }
    const replacements = [replacedContinuous, replacedLooping];
    const validReplacements = replacements.filter(a => a.length < basePoints.length + replacementSegmentPoints.length);
    if (validReplacements.length == 0)
        return [...basePoints];
    if (validReplacements.length == 1)
        return replacements[0];
    const longestValidReplacement = validReplacements.OrderBy(a => a.length).Last();
    return replaceFewestPoints ? longestValidReplacement : validReplacements.Except(longestValidReplacement)[0];
}
